export async function getAudioFromBlob(blob, fileName) {
  const audioBlob = await fetch(encodeURI(blob)).then((r) => r.blob());
  const audioFile = new File([audioBlob], fileName, { type: "audio/wav" });
  return audioFile;
}
